import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';

export const UserProfile: React.FC = () => {
  const { t } = useTranslation();
  const { user, signOut, loading } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);

  if (!user) return null;

  const handleSignOut = async () => {
    await signOut();
    setShowDropdown(false);
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  return (
    <div className="user-profile">
      <button 
        className="user-profile-button"
        onClick={toggleDropdown}
        disabled={loading}
      >
        <div className="user-avatar">
          {user.email?.charAt(0).toUpperCase()}
        </div>
        <span className="user-email">{user.email}</span>
        <span className="dropdown-arrow">▼</span>
      </button>

      {showDropdown && (
        <div className="user-dropdown">
          <div className="dropdown-item user-info">
            <strong>{t('signedInAs', { ns: 'auth' })}</strong>
            <span>{user.email}</span>
          </div>
          <div className="dropdown-divider"></div>
          <button 
            className="dropdown-item sign-out-button"
            onClick={handleSignOut}
            disabled={loading}
          >
            {loading ? t('loading', { ns: 'common' }) : t('signOut', { ns: 'auth' })}
          </button>
        </div>
      )}

      {/* Backdrop to close dropdown when clicking outside */}
      {showDropdown && (
        <div 
          className="dropdown-backdrop" 
          onClick={() => setShowDropdown(false)}
        />
      )}
    </div>
  );
}; 